/**
 * Sets the supplied function as a method named 'render' on a class instance.
 * This decorator may only be used on classes.
 *
 * @param {Function} render The render function that will replace the class' render method.
 */
export function renderMethod(render) {
  return (target) => {
    // The call arguments support stateful and stateless components in React Templates.
    target.prototype.render = function appliedRender() { return render.call(this, this.props, this.context); };
  };
}
